import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import { Row, Col, Container, Button, Card, Alert } from "react-bootstrap";
import { AxisDate, AxisDateTimeFull } from "../util/AxisDateTime";
import AxisSpinner from "./AxisSpinner";
import AuditReportModal from "../modals/AuditReportModal";
import { BsDatabaseFill, BsArrowRepeat } from "react-icons/bs";

const CertAuditReportTable = () => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showReport, setShowReport] = useState(false);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const page = await authAxios().get(
        "/api/backoffice/reporting/audit",
        config,
      );

      setDataSource(page?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const SpinnerOrData = (loading) => {
    if (loading) return (
      <div className="text-center py-5">
        <AxisSpinner loading={loading} />
      </div>
    );

    if (!dataSource || dataSource.length === 0) {
      return (
        <Alert variant="info">
          No audit reports available.
        </Alert>
      );
    }

    return (
      <Fragment>
        <div className="table-responsive">
          <Table striped bordered hover className="mb-0">
            <thead className="bg-light">
              <tr>
                <th style={{position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1}}>Month</th>
                <th style={{position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1}}>Report 1</th>
                <th style={{position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1}}>Report 2</th>
                <th style={{position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1}}>Last Modified</th>
              </tr>
            </thead>
            <tbody>
              {dataSource.map((report, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    // Ensure reports are sorted before showing the modal
                    const sortedReport = {
                      ...report,
                      reports: [...(report?.reports || [])].sort()
                    };
                    setSelected(sortedReport);
                    setShowReport(true);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{AxisDate(report?.month)}</td>
                  <td>{report?.reports ? [...report.reports].sort()[0] : ''}</td>
                  <td>{report?.reports ? [...report.reports].sort()[1] : ''}</td>
                  <td>{AxisDateTimeFull(report?.lastModified)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="mt-3">
          <small className="text-muted">
            {dataSource.length} report{dataSource.length !== 1 ? "s" : ""} found
          </small>
        </div>
      </Fragment>
    );
  };

  return (
    <Container fluid>
      <Card className="mb-4">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5 className="mb-0">
                <BsDatabaseFill className="me-2" />
                Audit Reports
              </h5>
            </Col>
            <Col xs="auto">
              <Button variant="outline-primary" size="sm" onClick={() => fetch()}>
                <BsArrowRepeat className="me-1" /> Refresh
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          {SpinnerOrData(loading)}
        </Card.Body>
      </Card>

      <AuditReportModal
        show={showReport}
        close={() => setShowReport(false)}
        report={selected}
        modalName="Audit Report"
        actionType="audit_file"
      />
    </Container>
  );
};

export default CertAuditReportTable;
